import styled from 'styled-components';
import { device } from '../../../../lib/media-query';

export const StyledContainer = styled.div`
    padding-top: 20px;
`;

export const StyledHeader = styled.p`
    color: #0b0b0b;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 26px;
    @media ${device.tablet} {
        font-size: 14px;
    }
`;

export const StyledText = styled.p`
    color: #0b0b0b;
    font-size: 14px;
    letter-spacing: 0;
    font-weight: normal;
`;

export const StyledUl = styled.ul`
    list-style-type: disc;
    padding-inline-start: 1.2em;
`;

export const StyledLi = styled.li``;

export const StyledPackagesContainer = styled.div`
    padding-left: 12px;
`;

export const StyledEquipmentPackage = styled.div`
    margin-bottom: 12px;
`;
